export default __webpack_public_path__ + "static/2-5b4822a44a2273a7be62b9c0d03341dc.jpg";